import { PortfolioSettingsModel } from "../../../../../portfolio-info/types/PortfolioSettingsModel";

class ChartTooltipService {
    getTooltipPositionForBalanceProfileChart = (
        portfolioSettings: PortfolioSettingsModel,
        fullSize: boolean
    ): string[] | undefined => {
        if (fullSize)
            return undefined;

        const useComparedPortfolio = portfolioSettings.useComparedPortfolio;

        const x = useComparedPortfolio ? '-488' : '-383';
        
        let y = '0';

        return [x, y];
    }

    getTooltipPositionForParametersProfileChart = (
        portfolioSettings: PortfolioSettingsModel,
        fullSize: boolean
    ): string[] | undefined => {
        if (fullSize)
            return undefined;

        const useComparedPortfolio = portfolioSettings.useComparedPortfolio;

        const x = useComparedPortfolio ? '-295' : '-226';
        let y = '0';

        return [x, y];
    }

    getTooltipPositionForImpliedVolatilityChart = (): string[] | undefined => {
        return ['600', '-95'];
    }

    getTooltipDivider(): string {
        return `<div style="padding-top: 5px; padding-bottom: 5px"><hr /></div>`;
    }
}

export const chartTooltipService = new ChartTooltipService();